import { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react'
import { Button, Checkbox, Image } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'

import RightNavCtrl from '../RightNavCtrl/RightNavCtrl'
import useStore from '@/hooks/useStore'
import PoiSearch from '@/components/Content/MapPart/PoiSearch'
import MapLayer from '@/components/Content/MapPart/MapLayer'
import rural01 from '@/assets/images/rural_Info_01.png'
import rural02 from '@/assets/images/rural_Info_02.png'
import rural03 from '@/assets/images/rural_Info_03.png'
import rural04 from '@/assets/images/rural_Info_04.png'
import rural05 from '@/assets/images/rural_Info_05.png'
import default01 from '@/assets/images/default_info_01.png'
import default02 from '@/assets/images/default_info_02.png'
import default03 from '@/assets/images/default_info_03.png'
import default04 from '@/assets/images/default_info_04.png'
import './index.less'
import Modal from '@/components/Modal'

function MapPart(props: any) {
  const { mapLoadedCallback } = props
  const mapStore = useStore('mapStore')
  const uiStore = useStore('uiStore')
  const mapRef = useRef<HTMLDivElement | null>(null)
  const [isModalOpen, setIsModalOpen] = useState(false) // 팝업 표시 상태
  const [isModalHidden, setIsModalHidden] = useState(false) // 다시 보지 않기 체크 상태
  const [imgCount, setImgCount] = useState(0) // 이미지 보기 번호
  const [hideForADay, setHideForADay] = useState(false) // 하루동안 보지 않기
  const [cviewer, setCviewer] = useState(null)

  useEffect(() => {
    console.log('mapStore', mapStore)
    if (mapStore.viewer === null)
      mapStore.initMap('view-container', isMapLoadedCallback)
    else {
      mapStore.initMap('view-container', isMapLoadedCallback)
    }
    // 로컬 스토리지의 key에 따라 안내 팝업 표시
    const isInfoHidden = localStorage.getItem('IS_INFO_HIDDEN')
    if (isInfoHidden == null) {
      showModal()
    }

    const isHidden = localStorage.getItem('hideForADay')
    if (isHidden) {
      const hideUntil = new Date(isHidden)
      if (hideUntil > new Date()) {
        setHideForADay(true)
      }
      else {
        setHideForADay(false)
      }
    }
  }, [])

  // 모달이 열릴 때 hideForADay 상태를 확인하여 보이거나 숨김
  useEffect(() => {
    if (isModalOpen && hideForADay) {
      handleOk()
    }
  }, [isModalOpen, hideForADay])

  useEffect(() => {
    console.log('cviewer', cviewer)
  }, [cviewer])

  const isMapLoadedCallback = async (viewer: any) => {
    setCviewer(viewer)
    if (mapLoadedCallback) {
      mapLoadedCallback(viewer)
    }
  }

  const showModal = () => {
    setIsModalOpen(true)
  }

  /**
   * 팝업 닫기 버튼 클릭 시 처리. 체크를 한 경우, 로컬 스토리지에 저장
   */
  const handleOk = () => {
    setIsModalOpen(false)
    if (isModalHidden === true)
      localStorage.setItem('IS_INFO_HIDDEN', 'true')
  }

  /**
   * 팝업 닫기 처리 (우측 상단 X버튼). 체크를 한 경우, 로컬 스토리지에 저장
   */
  const handleCancel = () => {
    setIsModalOpen(false)
    if (isModalHidden === true)
      localStorage.setItem('IS_INFO_HIDDEN', 'true')
  }

  /**
   * 순서별 이미지 이름 반환
   * @returns 이미지 이름
   */
  const getImage = () => {
    let img: string = ''
    if (uiStore.isClickRural) {
      switch (imgCount) {
        case 0: img = rural01
          break
        case 1: img = rural02
          break
        case 2: img = rural03
          break
        case 3: img = rural04
          break
        case 4: img = rural05
          break
        default: break
      }
    }
    else {
      switch (imgCount) {
        case 0: img = default01
          break
        case 1: img = default02
          break
        case 2: img = default03
          break
        case 3: img = default04
          break
        default: break
      }
    }
    return img
  }

  /**
   * 종류별 최대 넓이 반환
   * @returns 이미지 넓이 반환
   */
  const getImageWidth = () => {
    return uiStore.isClickRural ? 669 : 669
  }

  /**
   * 최대 이미지 갯수 반환
   * @returns 이미지 갯수
   */
  const getMaxCount = () => {
    return uiStore.isClickRural ? 5 : 4
  }

  /**
   * 이전 이미지 보기
   */
  const prevImg = () => {
    const nextCount = imgCount - 1
    setImgCount(nextCount < 0 ? 0 : nextCount)
  }

  /**
   * 다음 이미지 보기
   */
  const nextImg = () => {
    const nextCount = imgCount + 1
    if (uiStore.isClickRural) {
      if (nextCount > 4)
        setImgCount(4)
      else
        setImgCount(nextCount)
    }
    else {
      if (nextCount > 3)
        setImgCount(3)
      else
        setImgCount(nextCount)
    }
  }

  /**
   * 체크 박스 클릭 시 처리
   * @param e 체크 변경 이벤트
   */
  // const onChange = (e: CheckboxChangeEvent) => {
  //   setIsModalHidden(e.target.checked)
  // }

  // 사용자가 "오늘하루 팝업 보지않기" 버튼을 클릭할 때 호출되는 함수
  const handleHideForADay = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      localStorage.setItem('hideForADay', tomorrow.toString())
      setHideForADay(true)
      handleOk()
    }
    else {
      localStorage.removeItem('hideForADay')
      setHideForADay(false)
    }
  }

  return (
    <div className={'MapContainer'}>
        <div id="view-container" ref={mapRef} />
        {cviewer && <RightNavCtrl viewer={cviewer}></RightNavCtrl>}
        {cviewer && <PoiSearch />}
        {cviewer && <MapLayer />}
        <div style={{ display: isModalOpen && !hideForADay ? 'block' : 'none' }}>
        <Modal
          headerTitle={'안내사항'}
          styles={{
            position: 'fixed',
            width: 710,
            top: `${window.SystemConfig.uiConfig.headerHeight + 60}px`,
            left: `${uiStore.Content_Left_Width + 210}px`,
            zIndex: 10,
          }}
          isNotDragWithParent="dragModal_rightNavCtrl_2"
          visible={isModalOpen}
          handleClose={handleOk}
        >
          <Image width={getImageWidth()} src={getImage()} preview={false} />
          <div style={{ textAlign: 'center' }}>
            <div style={{ paddingBottom: '10px' }}>
              <LeftOutlined onClick={prevImg} />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{imgCount + 1} / {getMaxCount()}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <RightOutlined onClick={nextImg} />
            </div>
            <div>
            <Button type="primary" onClick={handleOk}>닫기</Button>
            </div>
            <div style={{ textAlign: 'left' }}>
                <Checkbox key="hideForADay" onChange={handleHideForADay}>
                  오늘하루 팝업 보지않기
                </Checkbox>
              </div>
          </div>
        </Modal>
      </div>
    </div>
  )
}

export default observer(MapPart)
